import { useEffect, useState } from 'react'
import { Button, Modal, Spinner } from '../ui'
import { enforceOilLimit, resolveLayerLabels, serializeLayerRows } from '../../lib/layeringPicker'
import LayeringPicker from './LayeringPicker'

export default function LayeringPickerModal({
  open,
  recommendationState,
  anchor,
  collection = [],
  logs = [],
  pairingRecommendations = [],
  unownedPairingRecommendations = [],
  pairingsLoading = false,
  pairingsError = '',
  initialLayeredWith = [],
  onClose,
  onSave,
}) {
  const [selected, setSelected] = useState([])
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!open) return
    setSelected(enforceOilLimit(resolveLayerLabels(initialLayeredWith, collection), anchor))
    setError('')
  }, [open, anchor?.id, initialLayeredWith, collection])

  const save = async () => {
    setSaving(true)
    setError('')
    try {
      await onSave(serializeLayerRows(selected))
      onClose()
    } catch (saveError) {
      setError(saveError?.message || 'Could not save these layers.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Build layers"
      maxWidth="max-w-lg"
      fullScreenMobile
      bodyClassName="flex flex-col !overflow-hidden sm:block sm:!overflow-visible"
    >
      <LayeringPicker
        recommendationState={recommendationState}
        anchor={anchor}
        collection={collection}
        logs={logs}
        pairingRecommendations={pairingRecommendations}
        unownedPairingRecommendations={unownedPairingRecommendations}
        pairingsLoading={pairingsLoading}
        pairingsError={pairingsError}
        selected={selected}
        onChange={setSelected}
        fullHeight
      />
      {error && <p className="mt-3 text-xs text-red-400" role="alert">{error}</p>}
      <div className="mt-3 flex shrink-0 gap-3 border-t border-white/10 pt-3 sm:mt-4 sm:border-0 sm:pt-0" data-layering-actions>
        <Button variant="ghost" onClick={onClose} className="flex-1">Cancel</Button>
        <Button onClick={save} disabled={saving} className="flex-1">
          {saving ? <><Spinner size="sm" /> Saving…</> : 'Save layers'}
        </Button>
      </div>
    </Modal>
  )
}
